import { useCallback, useState } from 'react';

export const useWindowedDialog = (initial = false) => {
  const [windowed, setWindowed] = useState(initial);

  const toggleWindowed = useCallback(() => setWindowed((prev) => !prev), []);
  const reset = useCallback(() => setWindowed(false), []);

  return {
    windowed,
    setWindowed,
    toggleWindowed,
    reset,
    dialogProps: { windowed },
    dialogHeaderProps: { windowed, onToggleWindowed: toggleWindowed },
  };
};
